// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"F0-z","smallCardRow":"G0-z","largeCardRow":"H0-z","productSearchRow":"I0-z","curatedRow":"J0-z"};